import { IVitalSign } from '../../store/slices/vitalSigns';
import { getBiomarkerLevelImage } from '../../utils/miscUtils';
import { useTranslation } from '../../hooks/useTranslations';
import { GLUCOSE_UOM_IDS } from '../../enums/enums';
import styles from './VitalSignResultsCard.module.scss';
import moment from 'moment';
import rightIcon from '../../assets/icons/rightIcon.svg';
interface VitalSignResultsV2Props {
  vitals: IVitalSign[];
  groupName?: string;
  handleClick?: (groupId: number) => void;
  groupId?: number;
}

const VitalSignResultsCard = ({
  vitals,
  groupName,
  handleClick,
  groupId,
}: VitalSignResultsV2Props) => {
  const { translations } = useTranslation();

  return (
    <div
      className={`${styles.container} ${handleClick ? styles.allowHover : ''}`}
      onClick={() =>
        handleClick && handleClick(groupId ? groupId : vitals[0].vital_sign_group_id_out)
      }
    >
      <div className={styles.header}>
        {groupName && (
          <h3>{groupName} </h3>

        )}
        <div className={styles.dateIcon}>
          <div className={styles.time}>
            {vitals.length
              ? vitals[0]?.vital_sign_group_name === 'Blood Glucose'
                ? `(${translations(`vitalsigns.mealTime.${vitals[0].mealtime_id}`)}) ${moment(
                  vitals[0]?.sample_date
                ).format(handleClick ? 'DD.MM.YYYY, HH:mm' : 'HH:mm')}`
                : moment(vitals[0]?.sample_date).format(handleClick ? 'DD.MM.YYYY, HH:mm' : 'HH:mm')
              : ''}
          </div>
          {handleClick && <img src={rightIcon} alt="right-icon" />}
        </div>
      </div >
      <div className={styles.vitalSignUnits}>
        {vitals.map((vital: any, index: number) => (
          <div key={index} className={styles.vitalSignUnit}>
            <div className={styles.vitalSignLabel}>
              <i
                className={getBiomarkerLevelImage(
                  ['Systolic', 'Diastolic'].includes(vital.property_name) &&
                    vital.reference_range_name === 'Low'
                    ? `${vital.reference_range_name}-blue`
                    : `${vital.reference_range_name}`
                )}
              ></i>
              <div className={styles.labels}>
                <span className={styles.name}>
                  {`${translations(
                    `vitalSignProperties.${vital.property_name.replace(/ /g, '_').toLowerCase()}`
                  )}`}
                </span>
                {vital.reference_range_name !== 'Default' && (
                  <span style={{ color: `#${vital.color_code}` }}>
                    {translations(`biomarkerDetails.${vital?.reference_range_name.toLowerCase()}`)}
                  </span>
                )}
              </div>
            </div>
            <div className={styles.vitalSignValue}>
              <p className={styles.value}>
                {vital.property_name === 'Body Weight'
                  ? vital?.result_weight
                  : vital?.property_value}
              </p>
              {vital.vital_sign_group_name === 'Blood Glucose' ? (
                <div className={styles.unit}>
                  {GLUCOSE_UOM_IDS[vital?.property_uom_id as keyof typeof GLUCOSE_UOM_IDS]}
                </div>
              ) : (
                <div className={styles.unit}>{vital.uom}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div >
  );
};

export default VitalSignResultsCard;
